module.exports = __webpack_public_path__ + "static/media/rute_araujo.59ea6b36.jpg";